import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/img/location.svg'


const _withScopeId = n => (_pushScopeId("data-v-0496091a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "map_canvas",
  id: "map_canvas"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createElementVNode("button", {
      class: "buttonOverMap left",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToCurrentPosition()))
    }, _hoisted_3)
  ]))
}